export default "__VITE_ASSET__CMT34x7d__"